/** Zoom for the report preview. The browser PDF bar stays hidden. */
export const REPORT_PREVIEW_ZOOM_MIN = 50;
export const REPORT_PREVIEW_ZOOM_MAX = 200;
export const REPORT_PREVIEW_ZOOM_STEP = 25;
export const REPORT_PREVIEW_ZOOM_DEFAULT = 100;

export function clampPreviewZoom(zoom: number): number {
  if (!Number.isFinite(zoom)) return REPORT_PREVIEW_ZOOM_DEFAULT;
  return Math.min(REPORT_PREVIEW_ZOOM_MAX, Math.max(REPORT_PREVIEW_ZOOM_MIN, zoom));
}

export function stepPreviewZoom(zoom: number, direction: 1 | -1): number {
  return clampPreviewZoom(zoom + direction * REPORT_PREVIEW_ZOOM_STEP);
}

/** Chrome and Firefox hide their PDF bar when these flags are in the URL. */
export function reportPreviewPdfSrc(src: string, zoom: number): string {
  const base = src.split('#')[0] ?? src;
  return `${base}#toolbar=0&navpanes=0&zoom=${clampPreviewZoom(zoom)}`;
}

export function savePdfUrl(url: string, filename: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.toLowerCase().endsWith('.pdf') ? filename : `${filename}.pdf`;
  link.click();
}

/** Prints the PDF without opening a new tab. */
export function printPdfUrl(url: string): void {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);
  const remove = () => {
    setTimeout(() => iframe.remove(), 1000);
  };
  iframe.onload = () => {
    const win = iframe.contentWindow;
    if (!win) {
      iframe.remove();
      return;
    }
    win.addEventListener('afterprint', remove, { once: true });
    win.focus();
    win.print();
    remove();
  };
  iframe.src = url;
}
